import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";

const NAV = [
  ["privacy", "Privacy"],
  ["terms", "Terms & Conditions"],
  ["cookies", "Cookies"],
  ["exam_conditions", "Exam Conditions"],
  ["scheme", "Certification Scheme"],
  ["proctoring", "Proctoring"],
];

export default function Policy() {
  const { key } = useParams();
  const [p, setP] = useState(null);

  useEffect(() => { api.get(`/policies/${key}`).then((r) => setP(r.data)).catch(() => setP(false)); }, [key]);

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-10 py-16" data-testid="policy-page">
      <div className="flex flex-wrap gap-2 mb-10">
        {NAV.map(([k, label]) => (
          <Link key={k} to={`/policies/${k}`} data-testid={`policy-tab-${k}`}
            className={`px-4 py-2 rounded-full text-sm font-medium border transition-colors ${key === k ? "bg-gold text-[#0B132B] border-gold" : "border-white/15 text-slate-300 hover:border-gold/50"}`}>
            {label}
          </Link>
        ))}
      </div>
      {p === false && <p className="text-slate-400">Policy not found.</p>}
      {p && (
        <article>
          <h1 className="font-display text-4xl font-extrabold text-white">{p.title}</h1>
          <p className="text-sm text-slate-500 mt-2">Last updated: {p.updated}</p>
          <div className="mt-8 space-y-6">
            {p.sections.map((s, i) => (
              <div key={i} className="bg-surface-card rounded-xl p-6 border border-white/10" style={{ backgroundColor: "#131C38" }}>
                <h3 className="font-display font-semibold text-white text-lg">{s.heading}</h3>
                <p className="text-slate-300 mt-2 leading-relaxed">{s.body}</p>
              </div>
            ))}
          </div>
        </article>
      )}
    </div>
  );
}
